module.exports = __webpack_public_path__ + "static/herobg-14-min-fcea574c7e452c1d7ea94e0e52969f9d.jpg";